export default __webpack_public_path__ + "static/media/logo.1f921963.png";